export function getWeeklyPlansPath() {
  return "/program/all";
}

export function getWeeklyPlanDetailsPath(weeklyPlanParentId, workoutId = null) {
  const searchParams = new URLSearchParams();

  if (workoutId) {
    searchParams.set("workoutId", workoutId);
  }

  const search = searchParams.toString();
  return `/program/all/${weeklyPlanParentId}${search ? `?${search}` : ""}`;
}

// The weekly builder keeps its plan in memory, so a reload needs the plan
// identity in the URL: `?plan=<weeklyPlanParentId>` (see useWeeklyPlanRestore).
export const WEEKLY_PLAN_QUERY_PARAM = "plan";

function withWeeklyPlanQuery(path, weeklyPlanParentId) {
  return weeklyPlanParentId
    ? `${path}?${WEEKLY_PLAN_QUERY_PARAM}=${encodeURIComponent(weeklyPlanParentId)}`
    : path;
}

export function getManualBuilderPath(weeklyPlanParentId = null) {
  return withWeeklyPlanQuery("/program/manual-builder", weeklyPlanParentId);
}

export function getManualBuilderWorkoutPath(workoutId, weeklyPlanParentId = null) {
  return withWeeklyPlanQuery(
    `/program/manual-builder/workout/${workoutId}`,
    weeklyPlanParentId
  );
}

export function getAIWeeklyPlanBuilderPath() {
  return "/program/ai-builder";
}
